(() => {
  const SELECTOR = '[data-postervoster-switcher]';
  const TAB_SELECTOR = '.postervoster-material-switcher__tab';

  const getMainSection = () => {
    // Dawn usually wraps main product section as: <section id="MainProduct-...">
    // But easiest stable target is the first "main-product" section element.
    const bySection = document.querySelector('section[id^="MainProduct-"]');
    return bySection || document.querySelector('main') || document.body;
  };

  const setLoading = (tabsEl, isLoading) => {
    tabsEl.querySelectorAll(TAB_SELECTOR).forEach(btn => {
      btn.disabled = isLoading;
      btn.classList.toggle('is-loading', isLoading);
    });
  };

  const activateTab = (tabsEl, handle) => {
    tabsEl.querySelectorAll(TAB_SELECTOR).forEach(btn => {
      const isActive = btn.dataset.postervosterProductHandle === handle;
      btn.classList.toggle('is-active', isActive);
      btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });
  };

  const fetchSectionHTML = async (handle) => {
    // Fetch only the main product section to avoid full page load
    const url = `/products/${handle}?section_id=main-product`;
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to fetch product section');
    return await res.text();
  };

  const replaceMainProduct = (html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');

    const newSection = doc.querySelector('section[id^="MainProduct-"]');
    const currentSection = document.querySelector('section[id^="MainProduct-"]');

    if (!newSection || !currentSection) {
      // Fallback: if structure differs, do a normal navigation
      return false;
    }

    currentSection.replaceWith(newSection);
    return true;
  };

  const updateURL = (handle) => {
    const newUrl = `/products/${handle}`;
    window.history.pushState({ postervoster: true, handle }, '', newUrl);
  };

  const reInitThemeStuff = () => {
    // Dawn components auto-init via custom elements on insert.
    // But some apps need a signal; dispatch a generic event.
    document.dispatchEvent(new Event('DOMContentLoaded', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('postervoster:product-switched', { bubbles: true }));
  };

  const onClick = async (e) => {
    const btn = e.target.closest(TAB_SELECTOR);
    if (!btn) return;

    const tabsEl = btn.closest(SELECTOR);
    if (!tabsEl) return;

    const handle = btn.dataset.postervosterProductHandle;
    if (!handle) return;

    // If already active, do nothing
    if (btn.classList.contains('is-active')) return;

    try {
      setLoading(tabsEl, true);

      const html = await fetchSectionHTML(handle);
      const ok = replaceMainProduct(html);

      if (!ok) {
        window.location.href = `/products/${handle}`;
        return;
      }

      updateURL(handle);
      reInitThemeStuff();
    } catch (err) {
      console.error(err);
      window.location.href = `/products/${handle}`;
    } finally {
      // After replacement, old tabsEl is gone. Nothing to unlock.
    }
  };

  const bind = () => {
    document.querySelectorAll(SELECTOR).forEach(el => {
      el.removeEventListener('click', onClick);
      el.addEventListener('click', onClick);
    });
  };

  // Initial bind
  document.addEventListener('DOMContentLoaded', bind);

  // Handle browser back/forward
  window.addEventListener('popstate', async (event) => {
    // If user navigates back/forward, we can simply reload to be safe
    // (most stable with apps like cart drawers)
    window.location.reload();
  });
})();